/**
 * Replace object API
 * Endpoint: POST /api/replace-object/single
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { appendLineageToForm } from "./studio_features";
import { appendAiImage, appendPreparedMask } from "./aiUpload";

const MULTIPART = (token) => ({
  ...createAuthConfig(token),
  timeout: 300000,
  headers: {
    ...createAuthConfig(token).headers,
    "Content-Type": "multipart/form-data",
  },
});

/**
 * Replace an object in an image.
 * @param {string} token - Clerk session token
 * @param {File|null} file - Image file (use null when sending image_url)
 * @param {object} [opts]
 * @param {string} [opts.image_url]
 * @param {string} [opts.replacement]
 * @param {string} [opts.target]
 * @param {File} [opts.mask]
 * @param {string} [opts.output_format]
 * @returns {Promise<{success: boolean, output_url?: string, credits_used?: number, remaining_credits?: number, creation_id?: string, message?: string}>}
 */
export async function replaceObjectSingle(token, file, opts = {}) {
  if (isMockApi) {
    const mockSrc = opts.image_url || (file ? URL.createObjectURL(file) : "");
    return {
      success: true,
      output_url: mockSrc || "",
      credits_used: 1,
      remaining_credits: 99,
    };
  }

  const form = new FormData();
  const prepared = await appendAiImage(form, file, {
    imageUrl: opts.image_url,
    requiredMessage: "replaceObjectSingle: provide file or opts.image_url",
  });
  if (opts.replacement) form.append("replacement", opts.replacement);
  if (opts.target) form.append("target", opts.target);
  await appendPreparedMask(form, opts.mask, prepared);
  if (opts.output_format) form.append("output_format", opts.output_format);
  appendLineageToForm(form, opts.lineage);

  const response = await apiClient.post(
    "/api/replace-object/single",
    form,
    MULTIPART(token)
  );
  return response.data;
}

const replaceObjectAPI = {
  replaceObjectSingle,
};

export default replaceObjectAPI;
